import { Loader } from '@/components/ui'
import { useProject } from '@/modules/projects'
import { isProjectProcessing } from '@/modules/projects/status'

// Hangs under the tabs card, which sits above it with `relative z-10`, so the card's border
// overlaps the strip and the two read as one piece. Renders nothing once processing is done.
export const ProcessingNotice = () => {
  const project = useProject()
  if (!isProjectProcessing(project)) return null

  return (
    <div className="-mt-2 flex items-center gap-2 rounded-b-lg border border-yellow-700/30 bg-amber-50 bg-barberpole-over-amber-200/20 px-3 pt-3.5 pb-1.5 font-medium text-sm text-yellow-800">
      <Loader className="text-yellow-700" />
      Project is processing. Figures are not final yet.
    </div>
  )
}
